var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25C19.4036 25 25 19.4036 25 12.5C25 5.59644 19.4036 0 12.5 0C5.59644 0 0 5.59644 0 12.5C0 19.4036 5.59644 25 12.5 25Z",
    fill: "url(#paint0_linear_178_25107)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4997 22.9154C6.75595 22.9154 2.08301 18.2424 2.08301 12.4987C2.08301 6.755 6.75595 2.08203 12.4997 2.08203C18.2436 2.08203 22.9163 6.755 22.9163 12.4987C22.9163 18.2424 18.2436 22.9154 12.4997 22.9154Z",
    fill: "url(#paint1_linear_178_25107)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M17.8539 9.59089C17.3589 9.59089 16.9577 9.99208 16.9577 10.487C16.9577 10.7295 17.0549 10.9486 17.2113 11.1099L15.3716 12.8934L13.4631 9.86667C13.7658 9.67589 13.9684 9.34096 13.9684 8.95669C13.9684 8.36148 13.4859 7.87891 12.8906 7.87891C12.2954 7.87891 11.8129 8.36148 11.8129 8.95669C11.8129 9.34023 12.0147 9.67482 12.3165 9.86586L10.4087 12.8934L8.56982 11.11C8.7263 10.9487 8.82354 10.7295 8.82354 10.487C8.82354 9.99208 8.42232 9.59089 7.92739 9.59089C7.43247 9.59089 7.03125 9.99208 7.03125 10.487C7.03125 10.9819 7.43247 11.3831 7.92739 11.3831C7.98182 11.3831 8.03455 11.3764 8.08635 11.3671L8.93607 15.4949H16.8452L17.6949 11.3671C17.7467 11.3765 17.7994 11.3831 17.8539 11.3831C18.3488 11.3831 18.75 10.9819 18.75 10.487C18.75 9.99208 18.3488 9.59089 17.8539 9.59089Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M9.03665 15.9844L8.57129 17.902H17.2094L16.7441 15.9844H9.03665Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4633 9.20026C16.9683 9.20026 16.5671 9.60146 16.5671 10.0964C16.5671 10.3388 16.6643 10.5579 16.8207 10.7193L14.981 12.5028L13.0725 9.47604C13.3752 9.28526 13.5778 8.95034 13.5778 8.56607C13.5778 7.97086 13.0952 7.48828 12.5 7.48828C11.9048 7.48828 11.4223 7.97086 11.4223 8.56607C11.4223 8.94961 11.6241 9.28419 11.9259 9.47523L10.0181 12.5028L8.17919 10.7194C8.33568 10.5581 8.43291 10.3389 8.43291 10.0964C8.43291 9.60146 8.03169 9.20026 7.53677 9.20026C7.04185 9.20026 6.64062 9.60146 6.64062 10.0964C6.64062 10.5913 7.04185 10.9925 7.53677 10.9925C7.5912 10.9925 7.64393 10.9858 7.69573 10.9765L8.54544 15.1043H16.4545L17.3043 10.9765C17.356 10.9858 17.4088 10.9925 17.4633 10.9925C17.9582 10.9925 18.3594 10.5913 18.3594 10.0964C18.3594 9.60146 17.9582 9.20026 17.4633 9.20026Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.64603 15.5938L8.18066 17.5114H16.8188L16.3534 15.5938H8.64603Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_178_25107",
    x1: -1.31836e-7,
    y1: 12.5,
    x2: 25,
    y2: 12.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCA05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAAC18"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_178_25107",
    x1: 2.08301,
    y1: 12.4987,
    x2: 22.9163,
    y2: 12.4987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAAC18"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCA05"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPremium);
export default __webpack_public_path__ + "static/media/premium.749fe97026ff26c1143671e823759d3a.svg";
export { ForwardRef as ReactComponent };